import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "relative mr-5" }
const _hoisted_2 = { class: "text-sm font-medium" }
const _hoisted_3 = { class: "bg-gray-100 py-2 px-4 ml-2 rounded-full hover:bg-gray-200 transition-all" }
const _hoisted_4 = {
  key: 0,
  class: "fixed z-20 top-header right-0 text-right"
}
const _hoisted_5 = { class: "bg-nucleus-white shadow-lg" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "text-sm" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _directive_click_away = _resolveDirective("click-away")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("span", {
      class: "align-middle cursor-pointer leading-none",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.toggleMenu()))
    }, [
      _createElementVNode("span", _hoisted_2, [
        _cache[1] || (_cache[1] = _createElementVNode("strong", null, "Selected region: ", -1)),
        _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.findCurrentRegion()?.name) + " (" + _toDisplayString(_ctx.findCurrentRegion()?.id) + ")", 1)
      ])
    ]),
    (_ctx.menu)
      ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.regions, (region, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: index,
                class: _normalizeClass(["p-5 opacity-50 hover:bg-gray-50 hover:opacity-100 cursor-pointer transition-all", { 'opacity-100': _ctx.currentRegion === region.id }]),
                onClick: ($event: any) => (_ctx.changeRegion(region.id))
              }, [
                _createElementVNode("span", _hoisted_7, _toDisplayString(region.name) + " (" + _toDisplayString(region.id) + ") ", 1)
              ], 10, _hoisted_6))
            }), 128))
          ])
        ])), [
          [_directive_click_away, _ctx.toggleMenu]
        ])
      : _createCommentVNode("", true)
  ]))
}